<template>
    <gofix-card fullContent class="mb-2">
        <gofix-default-table
                :settings="tableConfig"
                :table-items="tableItems"
                @new-item="openModalAdd"
                @load-items="getTableData"
                @delete-items="deleteItems"
                ref="gofixTable">
        </gofix-default-table>
        <b-modal :no-close-on-backdrop="true" id="modal-EditPrioritySet" :title="titleModal" hide-footer :centered="true" ref="modal-EditPrioritySet">
            <b-form class="pb-20">
                <b-row>
                    <b-col md="12">
                      <gofix-form-input label="Name" v-model="navision_file.reference_value_text"></gofix-form-input>
                    </b-col>
                </b-row>
            </b-form>
            <b-button-group class="d-block text-right" v-if="$checkRole($accessModule.posting_rules, 'update')">
                <gofix-button label="SUBMIT" @click="saveNavisionFile" :loading="isAction" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </gofix-card>
</template>
<script>
    import { filters } from '@/_filterVar.js'
    import { mapGetters, mapState } from "vuex";
    export default {
        name: 'navision-file',
        data() {
            return {
                tableConfig:{
                    name: 'posting-rules-navision-file',
                    controls:{
                        create: this.$checkRole(this.$accessModule.posting_rules, 'create'),
                        delete: this.$checkRole(this.$accessModule.posting_rules, 'delete')
                    },
                    dataSelect:{
                        company_name:{
                            value: [],
                            value_field: 'name',
                            text_field: 'name'
                        }
                    },
                    filter: JSON.parse(JSON.stringify(filters['navision_file'])),
                    page: 1,
                    limit: 100,
                    total: 0,

                    sortColumn: "reference_value_text",
                    sortDirection: "asc",
                },
                tableItems: [],

                isAction: false,
                navision_file: {
                    reference_type: 'Navision File Type',
                    reference_value_text: ''
                },
                titleModal: 'Create Navision File',
            }
        },
        computed: {
            ...mapGetters({
                UserLogin: "AuthController/user"
            })
        },
        mounted() {
            //
        },
        filters: {
            //
        },
        watch: {
        },
        methods: {
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();
                tableRequest.filter.reference_type.value = 'Navision File Type';
                await this.$store.dispatch("ReferenceController/getItems", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$bvToast.toast("Can not load items", {
                            title: `Notification`,
                            autoHideDelay: 3000,
                            variant: 'danger',
                            solid: true
                        })
                        reject();
                    })
            },
            async deleteItems(callback) {
                const { ids,filter, resolve,reject } = await callback();
                this.$store.dispatch("ReferenceController/deleteItem", ids)
                    .then(response => {
                        resolve(this.$notificationV2('deleting', 'navision_file'));
                    })
                    .catch(err =>{
                        reject(err);
                    });
            },
            saveNavisionFile(){
                if(this.isAction) {
                    return;
                }
                this.isAction = true;
                if (!this.navision_file.reference_value_text) {
                    this.isAction = false;
                    return this.$bvToast.toast('Name is a required field.', {
                        title: `Notification`,
                        autoHideDelay: 3000,
                        variant: 'danger',
                        solid: true
                    })
                }
                if(this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    this.$store.dispatch('ReferenceController/createItem', this.navision_file)
                        .then(result => {
                            this.isAction = false;
                            this.$refs.gofixTable.reloadTableKeepFilter();
                            this.$bvToast.toast(this.$notificationV2('adding', 'navision_file'), {
                                title: `Notification`,
                                autoHideDelay: 3000,
                                variant: 'success',
                                solid: true
                            })
                            this.$refs["modal-EditPrioritySet"].hide();
                        })
                        .catch(error => {
                            this.isAction = false;
                            if(error.response && error.response.data.error.message.error) {
                                return this.$bvToast.toast(error.response.data.error.message.error, {
                                    title: `Notification`,
                                    autoHideDelay: 3000,
                                    variant: 'danger',
                                    solid: true
                                });
                            }
                        })
                }, 300)
            },
            edit(item){
                this.titleModal = 'Edit Navision File';
                this.navision_file = Object.assign({}, item);
                this.$refs['modal-EditPrioritySet'].show()
            },
            openModalAdd (){
                this.titleModal = 'Create Navision File'
                this.navision_file.reference_value_text = ''
                this.$refs['modal-EditPrioritySet'].show()
            },
        }
    }
</script>
